module.exports = __webpack_public_path__ + "img/fdasfwfeaffasad.b9753860.png";